import { withNamespaces } from "react-i18next";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner
} from "reactstrap";

const CancelOnboardingModal = ({
    t,
    isOpen,
    toggle,
    onConfirm,
    cancelationIsInProcess
}) => {
    return (
        <Modal 
            isOpen={isOpen} 
            toggle={toggle} 
            centered
        >
            <ModalHeader 
                toggle={toggle}
            >
                {t('Cancel Onboarding Process')}
            </ModalHeader>

            <ModalBody>
                <p className="mb-2">
                    {t('Are you sure you want to cancel the onboarding process?')}
                </p>
                <p className="text-muted mb-0">
                    {t('Any uploaded files and validation progress will be permanently lost.')}
                </p>
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                    disabled={cancelationIsInProcess}
                >
                    {t('Continue Onboarding')}
                </Button>

                <Button 
                    color="danger" 
                    onClick={onConfirm}
                    disabled={cancelationIsInProcess}
                >
                    {cancelationIsInProcess && (
                        <Spinner 
                            size="sm"
                            color="white"
                            className="me-2"
                        />
                    )}
                    {t('Yes, Cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    CancelOnboardingModal
);
